import React, { useEffect, useState } from "react";
import { Hero } from "@/components/Hero";
import { CollectionsGrid } from "@/components/CollectionsGrid";
import { LifestyleSection } from "@/components/LifestyleSection";
import { ReviewsSection } from "@/components/ReviewsSection";
import { Newsletter } from "@/components/Newsletter";
import { ProductCard } from "@/components/ProductCard";
import { Link } from "react-router-dom";
import { fetchCollections, fetchProducts, fetchReviews } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Home() {
  const [collections, setCollections] = useState([]);
  const [bestsellers, setBestsellers] = useState([]);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetchCollections().then(setCollections).catch(() => {});
    fetchProducts()
      .then((all) => setBestsellers(all.filter((p) => p.tag === "Bestseller").slice(0, 4)))
      .catch(() => {});
    fetchReviews().then(setReviews).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      <Hero />
      <CollectionsGrid collections={collections} />

      {/* Bestsellers */}
      {bestsellers.length > 0 && (
        <section className="py-20 md:py-28 px-6 md:px-12 bg-white" data-testid="bestsellers-section">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
              <div>
                <p className="b2t-overline mb-3">The Bestsellers</p>
                <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-navy leading-[1.05]">
                  What the crew<br />
                  <span className="italic font-light text-seafoam-600">keeps reordering.</span>
                </h2>
              </div>
              <Link
                to="/shop"
                data-testid="bestsellers-view-all"
                className="text-sm font-bold uppercase tracking-[0.18em] text-navy hover:text-seafoam-600 transition-colors inline-flex items-center gap-2"
              >
                Shop All
                <ArrowRight className="w-4 h-4" strokeWidth={2} />
              </Link>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
              {bestsellers.map((p, i) => (
                <ProductCard key={p.id} product={p} index={i} />
              ))}
            </div>
          </div>
        </section>
      )}

      <LifestyleSection />
      <ReviewsSection reviews={reviews} />
      <Newsletter />
    </div>
  );
}
